/*
export const DEFAULT_EMAIL = 'Positive Salary Packaging <dean@positivesalarypackaging.com.au>'; // 'Positive Salary Packaging <fabian@jpmedia.com.au>'; //

export const sendEmail = (props) => {
    const { to, subject, text } = props;
    const from = props.from || DEFAULT_EMAIL;

   var formdata = new FormData();
   formdata.append("from", from);
   formdata.append("to", to);
   formdata.append("subject", subject);
   formdata.append("text", text);

   // This value was obtained by doing a curl command with -v
   // it is an encrypted api key
   const auth = 'Basic YXBpOmJhY2ZlNzZjZmRmOGIxYTk3MTA1OWU4YmM1NDljZDI5LTQ4NzlmZjI3LWNiNjc1NzRl';
   let headers = new Headers();
   headers.set('Authorization', auth);
   
   var requestOptions = {
     method: 'POST',
     body: formdata,
     redirect: 'follow',
     headers
   };
   
   return fetch("https://api.mailgun.net/v3/jpmedia.com.au/messages", requestOptions)
     .then(response => response.text())
     .then(result => {
         console.log(result)
     })
     .catch(error => {
         console.log('error', error)
     });
}
*/
export const formatCurrency = str => {
    return parseFloat(str).toFixed(2);
}
